// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__5duU2","disabled":"FileBtn_disabled__1sw_q","warn":"FileBtn_warn__Un-_s","fade":"FileBtn_fade__2uNiC"};